import { render, staticRenderFns } from "./universityTable.vue?vue&type=template&id=3c8e87a6&scoped=true"
import script from "./universityTable.vue?vue&type=script&lang=js"
export * from "./universityTable.vue?vue&type=script&lang=js"
import style0 from "./universityTable.vue?vue&type=style&index=0&id=3c8e87a6&prod&scoped=true&lang=less"
import style1 from "./universityTable.vue?vue&type=style&index=1&id=3c8e87a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8e87a6",
  null
  
)

export default component.exports